<template>
  <div>
    <div>     
      <transition name="fade"  mode="out-in">  
        <component v-if="isLoaded" v-bind:is="layout"></component>
        <div v-else class="flex justify-center items-center h-screen">
          <div v-html="svgText" class="svg-custom"></div>
        </div>
      </transition>      
    </div>    
  </div>
</template>

<script>
import { Auth, Storage, API } from 'aws-amplify'
import { mapMutations, mapActions } from 'vuex'
import { getUser } from '@/api/queries'
import loadValuelists from '@/scripts/loadValueLists'
import loadHistoryPlanTenant from '@/scripts/loadHistoryPlanTenant'
import DefaultLayout from '@/layouts/DefaultLayout'
import AuthLayout from '@/layouts/AuthLayout'
import BareLayout from '@/layouts/BareLayout'
import PrintLayout from '@/layouts/PrintLayout'
import svgText from '@/assets/svg/loading.svg';
import { previewDownloadedHeicImage } from '@/utilities/heicUtility.js'
import Intercom from '@intercom/messenger-js-sdk'

export default {
  components:{DefaultLayout, AuthLayout, BareLayout, PrintLayout},
  data(){
    return {   
      isLoaded: false,
      svgText   
    }
  },
  mounted(){    
    this.checkAuthState()
  },
  computed:{
    layout(){
      let currentLayout = window.location.pathname.includes('/u/') ? 'BareLayout' : 'DefaultLayout';
      return this.$route.meta.layout || currentLayout;
    }
  },
  
  watch:{
    '$route.query.error'(){
      this.checkForErrors()
    }
  },


  methods:{
    ...mapMutations([
      'setSessionInfo',
      'setUserInfo',
      'setCompanyLogo'
    ]),
    ...mapActions([
      'loadLabelTypes',
      'loadSystemList',
      'loadSystemSettingOptionsAsync'
    ]),

    checkForErrors(){
      var error = this.$route.query.error;
      if(error){
        this.$notify.error({
          title: "Error",
          message: error
        })
      }
    },
    async checkAuthState(){
      try{
        if (window.location.pathname.includes('/u/')) {
          return;
        } 
        //Set session info
        console.log("check auth")
        var session = await Auth.currentUserPoolUser()
        
        const userInstance = this.generateUUID()
        sessionStorage.setItem("userInstance", userInstance)

        this.setSessionInfo(session)

        //Set user data
        const userId = session.attributes['custom:user_id'];
        const supportAdministrator = localStorage.getItem('supportAdministrator')
        this.$store.commit('setSupportAdministrator', supportAdministrator ? true : false)
        const user = await this.api(getUser, {id: supportAdministrator ? supportAdministrator : userId})
        this.setUserInfo(user.data.getUser)

        //Intercom
        const intercomPayload = {
          app_id: process.env.VUE_APP_ID_INTERCOM,
          user_id: userId,
          email: user.data.getUser.email,
          name: user.data.getUser.firstName + ' ' + user.data.getUser.lastName,
          role: user.data.getUser.role,
          phone: user.data.getUser.phone,
          "User LogRocket URL": `https://app.logrocket.com/${process.env.VUE_APP_HERA_LOGROCKET_ID}/sessions?u=${userId}`,
          "User Zoho CRM ID": user.data.getUser.zohoCrmContactRecordId,
          company: {
            company_id: user.data.getUser.tenant.id,
            name: user.data.getUser.tenant.companyName,
            plan: this.toTitleCase(user.data.getUser.tenant.accountPremiumStatus?.[0] || ''),
            "Company LogRocket URL": this.getCompanyLogRocketURL(user.data.getUser.tenant.id),
            "Company Zoho CRM ID": user.data.getUser.tenant.zohoCrmAccountRecordId,
          },
        }
        const userHash = await this.getUserHash(userId)
        if(userHash) intercomPayload.user_hash = userHash
        const env = this.getEnvironment()
        if(env !== 'production'){
          intercomPayload.Environment = env
          intercomPayload.company['Company Environment'] = env
        }
        Intercom(intercomPayload)
        
        //Load value lists
        await loadValuelists(this, user.data.getUser.tenant.id)

        //Load Custom List Values
        await this.loadCustomList()

        //Update company logo
        const companyLogoS3Key = user.data.getUser.tenant.logo
        if(companyLogoS3Key){
          let imageUrl = null
          if(/\.heic$/i.test(companyLogoS3Key)){
            const file = await Storage.get(companyLogoS3Key, {download: true})
            const blob = await previewDownloadedHeicImage(file)
            imageUrl = URL.createObjectURL(blob)
          }else{
            imageUrl = await Storage.get(companyLogoS3Key)
          }
          this.setCompanyLogo(imageUrl)
        }

        //load History Plan for read-only access
        await loadHistoryPlanTenant(user.data.getUser.tenant.group)
        //Load labels
        await this.loadLabelTypes()
        //Load System List 
        await this.loadSystemList();

        await this.loadSystemSettingOptionsAsync()
        
      }catch(e){
        this.setSessionInfo(null)
        this.setUserInfo(null)
      }finally{
        this.isLoaded = true
      }
    },

    getCompanyLogRocketURL(tenantId){
      const filters = JSON.stringify([
        {
          type: "userTrait",
          operator: {
            name: "is",
            type: "IS",
            hasStrings: true,
            autocompleteEnabled: true
          },
          strings: [`company_id:${tenantId}`]
        }
      ])
      const companyLogRocketURL = `https://app.logrocket.com/${process.env.VUE_APP_HERA_LOGROCKET_ID}/sessions?filters=${filters}`
      return companyLogRocketURL
    },

    async getUserHash(userId){
      try{
        let apiName = 'intercomUpdateCompanies'
        let path = `/user-hash/${userId}`
        let params = {
          headers: {
            'Content-Type' : 'application/json'
          } 
        }
        const response = await safeFunction(API.get)(apiName, path, params)
        return response.hash
      }catch(e){
        console.error(e)
        return null
      }
    }

  }
}
</script>
<style scoped>

.items-center {
  align-items: center;
}
.svg-custom {
  width: 5rem; 
  height: auto; 
}
</style>
<style lang="scss">

</style>